import { useContext } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";

const TableHeader = () => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className="invoiceListTableHeader accountTableHeaderMain">
      <Box className={`invListTableHeaderCol fourColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.date_and_time}
        >
          {I18n.date_and_time}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fourColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.account}
        >
          {I18n.account}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fourColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.description}
        >
          {I18n.description}{" "}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol fourColumn justifyEnd`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor textRight"}
          key={I18n.amount}
        >
          {I18n.amount}{" "}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default TableHeader;
